import { type IAdFoxBannerOnErrorError, connect } from '@cian/adfox-component';
import { withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';

import { memo, useCallback, useMemo, useState } from 'react';

import { useAdfoxContext } from '../AdfoxContext';

import { OwnTemplates } from './OwnTemplates';

const AdFoxBannerComponent = connect(OwnTemplates);

type AdFoxBannerProps = {
  galleryPosition?: number;
  position?: number;
  onClick?(event: MouseEvent): void;
  onStub?(): void;
  onError?(error: IAdFoxBannerOnErrorError): void;
};

export const AdFoxBanner = memo<AdFoxBannerProps>(function AdFoxBanner(props) {
  const { onStub, onError, onClick, position, galleryPosition } = props;

  const { params, sizes, postViewAnalyticsData } = useAdfoxContext();

  const [isHidden, setHidden] = useState(false);

  const handleStub = useCallback(() => {
    setHidden(true);

    onStub?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleError = useCallback((error: IAdFoxBannerOnErrorError) => {
    setHidden(true);

    onError?.(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo(() => {
    if (isHidden) {
      return null;
    }

    const AdfoxWithPostView = withAdfoxPostViewAnalytics(AdFoxBannerComponent, {
      position,
      galleryPosition,
      onClick,
      ...postViewAnalyticsData,
    });

    return <AdfoxWithPostView {...sizes} params={params} onError={handleError} onStub={handleStub} />;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHidden, sizes]);
});
